import React from "react";
import { useOutlet, useNavigate } from "react-router-dom";
import { PageHelmet } from "@/components/PageHelmet/PageHelmet";
import { AppSidebar } from "@/components/app-sidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { ThemeProvider } from "@/context/ThemeProvider";
import { usePortalPermissions } from "@/hooks/usePortalPermissions";

export const AdminPortalLayout = () => {
    const outlet = useOutlet();
    const { canAccessPortal } = usePortalPermissions();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!canAccessPortal) {
            navigate("/");
        }
    }, [canAccessPortal, navigate]);

    if (!canAccessPortal) {
        return null;
    }

    return (
        <ThemeProvider>
            <PageHelmet
                title="Admin Portal"
                robotsOverride="noindex, nofollow"
            />
            <SidebarProvider
                style={{
                    "--sidebar-width": "12rem",
                    "--sidebar-width-icon": "3rem",
                }}
            >
                <div className="flex min-h-screen w-full">
                    <AppSidebar
                        collapsible="icon"
                        variant="inset"
                    />
                    <SidebarInset>{outlet}</SidebarInset>
                </div>
            </SidebarProvider>
        </ThemeProvider>
    );
};
